import type { AllRouteEndpoints } from "../routeTypes";

export const canvasQaRun = "/:app_group_id/canvas_qa_runs/:canvas_id";

export const canvasQaRunCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/canvas_qa_runs/:canvas_id"];
